<template>
    <div>
        <!--<p>TODO: Hier nog een overzicht van de offerte tonen of enkel de storage clearen?</p>-->
    </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
    name: 'offerteCart',
    data() {
        return {};
    },
    methods: {
        ...mapMutations({
            clearStorage: 'clearStorage'
        })
    },
    mounted() {
        this.clearStorage();
    }
};
</script>
